import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { getTenant } from '../../services/tenantService';
import Breadcrumbs from '../../components/ui/Breadcrumbs';
import Tabs from '../../components/ui/Tabs';
import TenantAdminTab from './tab-pages/TenantAdminTab';
import TenantModulesTab from './tab-pages/TenantModulesTab';
import { useAuth } from '../../context/AuthContext';

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const StickyHeader = styled.div`
  flex-shrink: 0;
`;

const TabContent = styled.div`
  flex: 1;
  overflow-y: auto;
  padding-top: 8px;
`;

export default function TenantDetailsPage() {
  const { t } = useTranslation();
  const { id } = useParams();
  const { isSuperAdmin } = useAuth();
  const [tenant, setTenant] = useState(null);
  const [activeTab, setActiveTab] = useState('admins');

  useEffect(() => {
    getTenant(id)
      .then((res) => setTenant(res.data?.data))
      .catch(() => {});
  }, [id]);

  // Module assignment is a system operation — superAdmin only.
  const tabs = [
    { key: 'admins', label: t('tenant.tabAdmins') },
    ...(isSuperAdmin ? [{ key: 'modules', label: t('tenant.tabModules') }] : []),
  ];

  return (
    <PageContainer>
      <StickyHeader>
        <Breadcrumbs items={[
          { label: t('tenant.title'), path: '/tenants' },
          { label: tenant?.name || '...' },
        ]} />

        <Tabs tabs={tabs} activeTab={activeTab} onChange={setActiveTab} />
      </StickyHeader>

      <TabContent>
        {activeTab === 'admins' && <TenantAdminTab tenantId={id} />}
        {activeTab === 'modules' && <TenantModulesTab tenantId={id} />}
      </TabContent>
    </PageContainer>
  );
}
